function assignRowKeys(products) {
  products.forEach((product, position) => {
    product.rowKey = `order-product:${position}`;
  });

  return products;
}

module.exports = { assignRowKeys };
